const COUPONS = {
  COUPON_WITH_NO_CODE: 'Link cuponado',
  COUPON_LIMIT_LOGGED_IN: 20,
  COUPON_LIMIT_LOGGED_OUT: 40,
  COUPONS_LIMIT: 16,
  COUPONS_STORE_GA_EVENT_CATEGORY: 'coupons_store',
  CTA_CONFIG: {
    // Each entry inserts a CTA after the Nth coupon.
    DESKTOP_SEQUENCE: [
      { type: 'wishlist', afterCoupon: 2 },
      { type: 'whatsapp-group', afterCoupon: 5 },
    ],
    MOBILE_SEQUENCE: [
      { type: 'app-download', afterCoupon: 2 },
      { type: 'whatsapp-group', afterCoupon: 5 },
    ],
  },
  DOMAIN: 'coupon',
  // Values from couponTag audit (Task 1.0). 'Link Cuponado' differs in casing
  // from COUPON_WITH_NO_CODE ('Link cuponado') — the DB value uses capital C.
  NOISE_TAGS: new Set([
    'Link Cuponado',
    'Não é necessário aplicar o cupom de desconto',
    'Exclusivo APP',
  ]),
  PROMOBIT_COUPON_CODE: 'promobit',
  STATUS: {
    APPROVED: 'APPROVED',
    FINISHED: 'FINISHED',
  },
  VISIBILITY_STATUS: {
    ALL: 'ALL',
    APP_ONLY: 'APP_EXCLUSIVE',
    LOGGED_ONLY: 'LOGGED',
    UNLOGGED_ONLY: 'UNLOGGED',
  },
};

export default COUPONS;
